module.exports = __webpack_public_path__ + "images/halloween_lp/sec01_step1_ea34da8479b2a83525c93af321f972f3.png";